import React from "react";
import styled from "styled-components";
import sassVars from "../../../styles/variables.module.scss";

const {
  yellow,
  gray,
  fontInterstate,
} = sassVars;

interface IOwnProps {
  isActive: boolean;
  helpMenuList: Array<{ id: number; item: string; icon: string }>;
  dropdownRef?: React.Ref<HTMLDivElement>;
  onClickMenu: (e: React.SyntheticEvent<HTMLElement>, item: string) => void;
}
const HelpMenu: React.FC<IOwnProps> = ({
  helpMenuList,
  dropdownRef,
  isActive,
  onClickMenu,
}: IOwnProps) => {
  return (
    <HelpMenuStyled>
      <nav
        ref={dropdownRef}
        className={`menu ${isActive ? "active" : "inactive"}`}
      >
        <div className="top"></div>
        <ul>
          {helpMenuList.length > 0 &&
            helpMenuList.map((menu) => {
              return (
                <li
                  onClick={(e) => {
                    onClickMenu(e, menu.item);
                  }}
                  key={menu.id}
                  className="widget-menu-list"
                >
                  <img src={menu.icon} alt="Menu Icons" /> &nbsp; {menu.item}
                </li>
              );
            })}
        </ul>
      </nav>
    </HelpMenuStyled>
  );
};
export default HelpMenu;

const HelpMenuStyled = styled.div`
  & .menu {
    background: #3a3a4a;
    border-radius: 1px;
    position: absolute;
    top: 61px;
    right: 229px;
    width: 11rem;
    box-shadow: 0 1px 8px rgba(0, 0, 0, 0.3);
    opacity: 0;
    visibility: hidden;
    & .se-dropdown-item {
    color: #ffffff !important;
    outline: #2e2e38 !important;
    z-index: 2;
    position: relative;
    display: flex;
    align-items: center;
    width: 100%;
    padding-left: 0px;
    font-size: 14px;
    clear: both;
    text-align: inherit;
    text-decoration: none;
    white-space: nowrap;
    border: none;
    outline: 1px solid transparent;
    font-family: ${fontInterstate};
    background: transparent;
    border-bottom: 1px solid ${gray};
    padding-bottom: 0px  !important ;
  }
   }
      & .menu.active {
        opacity: 1;
        visibility: visible;
        z-index: 999;
        position: absolute;
      }
      & .menu ul {
        list-style: none;
        position: relative;
        right: 0px;
        padding: 0;
        margin: 0;
      }
      & .menu li {
        text-align: left;
        cursor: pointer;
        outline: 1px solid transparent;
        font-weight: 300;
        font-family: ${fontInterstate};
        font-size: 14px;
        padding-bottom: 0.7rem;
        margin-bottom: 0px;
        padding-left: 1rem;
        padding-left: 0.5rem;
        display: flex;
        align-items: baseline;
      }
      & .menu .widget-menu-list:hover {
        color: ${yellow};
        background: #191a24;
      }
      & .menu li a {
        text-decoration: none;
        color: #333333;
        padding: 15px 20px;
        display: block;
      }
      & .menu li img {
        position: relative;
        top: 6px;
      }
    }
    }
  `;
